import { z } from "zod";

export const contactFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: "Name is required" })
    .max(200, { message: "Name must be less than 200 characters" })
    .regex(/^[a-zA-Z\s\-'.]+$/, { message: "Name contains invalid characters" }),
  email: z
    .string()
    .trim()
    .min(1, { message: "Email is required" })
    .email({ message: "Please enter a valid email address" })
    .max(255, { message: "Email must be less than 255 characters" }),
  phone: z
    .string()
    .trim()
    .min(1, { message: "Phone number is required" })
    .max(50, { message: "Phone number must be less than 50 characters" })
    .regex(/^[+]?[\d\s\-().]+$/, { message: "Please enter a valid phone number" }),
  country: z
    .string()
    .min(1, { message: "Country is required" }),
  treatment_interest: z
    .string()
    .min(1, { message: "Treatment category is required" })
    .max(200, { message: "Treatment interest must be less than 200 characters" }),
  travel_timeframe: z
    .string()
    .min(1, { message: "Travel timeframe is required" }),
  urgency: z
    .string()
    .min(1, { message: "Urgency is required" }),
  message: z
    .string()
    .trim()
    .max(5000, { message: "Message must be less than 5000 characters" })
    .optional()
    .or(z.literal("")),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

export function validateContactForm(data: unknown): { 
  success: boolean; 
  data?: ContactFormData; 
  errors?: Record<string, string> 
} {
  const result = contactFormSchema.safeParse(data);
  
  if (result.success) {
    return { success: true, data: result.data };
  }
  
  const errors: Record<string, string> = {};
  result.error.issues.forEach((issue) => {
    const path = issue.path[0] as string;
    if (!errors[path]) {
      errors[path] = issue.message;
    }
  });
  
  return { success: false, errors };
}
